import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersMenu',
  setup(__props) {

const router = useRouter();
const route = useRoute();

function showUsers() {
  router.push('/users');
}
function showCommunity() {
  router.push('/users/communities');
}
function showOrgs() {
  router.push('/users/organizations');
}

function getPage(path: string): string {
  switch (path) {
    case '/users':
      return 'List';
    case '/users/communities':
      return 'Communities';
    case '/users/organizations':
      return 'Organizations';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { app: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs, {
        items: ['Users', getPage(_unref(route).path)]
      }, null, 8, ["items"]),
      (_unref(route).path !== '/users')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            flat: "",
            color: "info",
            onClick: showUsers
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("List")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/users/communities')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            flat: "",
            color: "info",
            onClick: showCommunity
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Communities")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).path !== '/users/organizations')
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            flat: "",
            color: "info",
            onClick: showOrgs
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Organizations")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})